import { ReactElement } from 'react';
import { TableFilterOptionItem } from '~/components/Table/components/filters/types';

export type StatusConfig = {
  color: string;
  Icon: ReactElement;
  label: string;
};

export enum ClusterFiltersType {
  ID = 'id',
  STATUS = 'status',
  CREATED_ON = 'createdOn',
  CREATED_BY = 'createdBy',
}

export type ClusterFilters = {
  [K in ClusterFiltersType]: TableFilterOptionItem[];
};
